import React from 'react';
import { Link } from "react-router-dom";

// function MenuItem(props) {
//     return (
//         <li className="dropdown">
//         <a href="/">{props.text}</a><div className="menu_next"></div>
//             <ul className="submenu">
//                 <li>
//                 <a href='/'>submenu text</a>
//                 </li>
//             </ul>
//         </li>
//     );
// }

const Header = () => {
    return (
        <div className="HedaerContainer">
            <div className="HeaderBlock">
                <ul className="menu">
                    <li className="dropdown">
                        <Link to="/" className="home-icon" title="Գլխավոր էջ">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                 fill="currentColor">
                                <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                            </svg>
                        </Link>
                        <div className="menu_next"></div>
                        <ul className="submenu">
                            <li>
                                <a href='/'>submenu text</a>
                            </li>
                        </ul>
                    </li>

                    <li className="dropdown">
                        <Link className='aygiActive' to="/garden">Տեսանյութեր</Link>
                        <div className="menu_next"></div>
                        <ul className="submenu">
                            <li>
                                <a href='/'>submenu text</a>
                            </li>
                        </ul>
                    </li>

                    <li className="dropdown">
                        <Link to="/publications-and-consulting/publications" className='HrpActive'>Հրապարակումներ և
                            խորհրդատվություն</Link>
                        <div className="menu_next"></div>
                        <ul className="submenu">
                            <li>
                                <a href='/'>submenu text</a>
                            </li>
                        </ul>
                    </li>

                    <li className="dropdown">
                        <Link to="/trainings" className="VerIsActive">Վերապատրաստումներ</Link>
                        <div className="menu_next optim"></div>
                        <ul className="submenu">
                            <li>
                                <a href='/'>submenu text</a>
                            </li>
                        </ul>
                    </li>

                    <li className="dropdown">
                        <Link to="/programs/companies" className="SetColor">Ծրագրեր</Link>
                        <div className="menu_next"></div>
                        <ul className="submenu">
                            <li>
                                <a href='/'>submenu text</a>
                            </li>
                        </ul>
                    </li>

                    <li className="dropdown">
                        <Link to="/services" className="SetColorMy">Ծառայություններ</Link>
                        <ul className="submenu">
                            <li>
                                <a href='/'>submenu text</a>
                            </li>
                        </ul>
                    </li>

                </ul>
            </div>
        </div>
    );
}

export default Header;
